
export const CLEAR_OWNER = 'clear-owner';
export const FETCHING_OWNER_BY_KEY = 'fetching-owner-by-key';
export const FETCH_BY_KEY_SUCCESS = 'fetch-by-key-success';
export const FETCHING_OWNER_BY_ID = 'fetching-owner-by-id';
export const FETCH_BY_ID_SUCCESS = 'fetch-by-id-success';
export const FETCH_FAILURE = 'fetch-failure';
export const SUBMITING_OWNER = 'submiting-owner';
export const FETCH_OWNER_SUCCESS = 'fetch-owner-success';
export const CREATE_OWNER_FAILURE = 'create-owner-failure';
export const UPDATE_OWNER_FAILURE = 'update-owner-failure';
export const DELETE_OWNER_FAILURE = 'delete-owner-failure';
export const FETCHING_OWNERS_BY_FILTER = 'fetching-owners-by-filter';
export const FETCHING_OWNERS_BY_FILTER_SUCCESS = 'fetching-owners-by-filter-success';
export const FETCH_OWNERS_FAILURE = 'fetch-owners-failure';
export const FETCHING_ADMITTED_COUNT = 'fetching-owner-admitted-count';
export const FETCH_ADMITTED_COUNT_SUCCESS = 'fetch-owner-admitted-count-success';
export const FETCH_ADMITTED_COUNT_FAILED = 'fetch-owner-admitted-count-failed';
export const CHANGE_FILTER_VALUE = 'change-filter-value';
export const PERSIST_FILTER = 'persist-filter';
export const CLEAR_FILTER = 'clear-filter';
